/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Errors_Failedtosave2Inputs */

const he_profile_errors_failedtosave2 = /** @type {(inputs: Profile_Errors_Failedtosave2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`שמירת הפרופיל נכשלה`)
};

const en_profile_errors_failedtosave2 = /** @type {(inputs: Profile_Errors_Failedtosave2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to save profile`)
};

/**
* | output |
* | --- |
* | "Failed to save profile" |
*
* @param {Profile_Errors_Failedtosave2Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const profile_errors_failedtosave2 = /** @type {((inputs?: Profile_Errors_Failedtosave2Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Errors_Failedtosave2Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_profile_errors_failedtosave2(inputs)
	return en_profile_errors_failedtosave2(inputs)
});
export { profile_errors_failedtosave2 as "profile_errors_failedToSave" }